const UNIT_SECONDS = {
    hours: 3600,
    days: 86400,
    weeks: 604800,
};
export function expiresInToSeconds(expiresIn) {
    return expiresIn.value * UNIT_SECONDS[expiresIn.unit];
}
//# sourceMappingURL=types.js.map